import { TOOLBOX } from "@volca/ui/components/ui/empty-machine";
import { MachineEmptyState } from "@volca/ui/components/ui/machine-empty-state";

export const NoOnboardingProducts = () => (
  <MachineEmptyState
    art={TOOLBOX}
    layout="workspace"
    title="No products are selected for setup"
    description="Your setup checklist will appear once products have been selected for your business."
    footnote="Contact Volca for help getting started."
  />
);
